import dayjs from 'dayjs';
import { useCallback, useEffect, useRef, useState, } from 'react';
export const useRecordingTimer = () => {
    const [time, setTime] = useState({
        formatted: '00:00:00',
        seconds: 0,
    });
    const [isTimerActive, setIsTimerActive] = useState(false);
    const intervalRef = useRef(null);
    const start = useCallback(() => {
        setIsTimerActive(true);
        const startTime = Date.now();
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
        }
        intervalRef.current = window.setInterval(() => {
            const elapsedMs = Date.now() - startTime;
            setTime({
                formatted: dayjs.duration(elapsedMs).format('HH:mm:ss'),
                seconds: Math.floor(elapsedMs / 1000),
            });
        }, 1000);
    }, []);
    const reset = useCallback(() => {
        setIsTimerActive(false);
        setTime({
            formatted: '00:00:00',
            seconds: 0,
        });
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    useEffect(() => {
        return () => {
            if (intervalRef.current !== null) {
                clearInterval(intervalRef.current);
            }
        };
    }, []);
    return {
        time,
        isTimerActive,
        start,
        reset,
    };
};
